import { useEffect, useMemo } from 'react';
import { PRICE_SCHEME_ID } from 'src/constants';
import { useLocalStorage } from 'usehooks-ts';
import { usePriceSchemes } from '../usePriceSchemes';

export const useSelectedPriceScheme = () => {
  const { data: priceSchemes } = usePriceSchemes();
  const [selectedPriceSchemeId, setSelectedPriceSchemeId] = useLocalStorage<string | null>(PRICE_SCHEME_ID, null);

  useEffect(() => {
    if (priceSchemes && priceSchemes.length > 0) {
      const selectedScheme = priceSchemes.find((scheme) => scheme.id === selectedPriceSchemeId);
      if (!selectedScheme) {
        const sortedSchemes = [...priceSchemes].sort(
          (a, b) => b.modificationDateTime.valueOf() - a.modificationDateTime.valueOf(),
        );
        const mostRecentlyModifiedScheme = sortedSchemes[0];
        setSelectedPriceSchemeId(mostRecentlyModifiedScheme.id);
      }
    }
  }, [priceSchemes, selectedPriceSchemeId]);

  return useMemo(
    () => ({
      selectedPriceSchemeId,
      setSelectedPriceSchemeId,
    }),
    [selectedPriceSchemeId, setSelectedPriceSchemeId],
  );
};
